// noinspection JSUnusedGlobalSymbols

/**
 * Because AG Grid can initialize a row without any data and
 * call the cell renderer with an undefined value this function
 * creates a new function to check for that and call the passed function.
 */
function createCellRenderer(getterFunction) {
	return params => {
		if (params && params.data) {
			return getterFunction(params);
		}
		return null;
	}
}

/**
 * Returns a cell renderer that will display only up to the given chars
 *
 * @param maxChars The max number of chars to display
 * @param last Start at the end
 * @return {(function(*): (*|null))|*}
 */
function createTruncatedTextCellRenderer(maxChars = 10, last = false) {
	return createCellRenderer(params => {
		const value = params.value;

		let result;
		if (last) {
			result = value.substring(value.length - maxChars)
		} else {
			result = value.substring(0, maxChars);
		}

		// Check if string was shortened so we can append ellipsis
		if (value.length > result.length) {
			if (last) {
				result = `…${result}`;
			} else {
				result = `${result}…`
			}
		}

		return result;
	})
}

/**
 * Returns a function to handle row double click events
 *
 * @param {(data: Object,event: import('ag-grid-community/dist/lib/events.d.ts').RowDoubleClickedEvent) => void} doubleClickHandler
 */
function createDoubleClickHandler(doubleClickHandler) {
	return function (event) {
		// Only call handler if row has data loaded
		if (event && event.data) {
			// Clean up any selection caused by the double click
			// noinspection JSUnresolvedVariable
			(window.getSelection ? window.getSelection() : document.selection).empty()

			// We assume this will contain the api as is it bound
			// to the gridOptions on creation
			/** @type import('ag-grid-community/dist/lib/gridApi.d.ts').GridApi*/
			const api = this.api;
			if (api) {
				// Clean up any cell selection
				api.clearFocusedCell();
			}

			// Call handler
			doubleClickHandler(event.data, event);
		}
	};
}


export {
	createCellRenderer,
	createTruncatedTextCellRenderer,
	createDoubleClickHandler
}
